export default [
  {
    name: 'Birthday',
    value: 'birthday'
  }, {
    name: 'Lost Customer',
    value: 'lost-customers'
  }, {
    name: 'Sign Up Anniversary',
    value: 'signup-anniversary'
  }, {
    name: 'Wedding Anniversary',
    value: 'wedding-anniversary'
  }
]



/** WEBPACK FOOTER **
 ** ./src/forms/options/recurringOptions.js
 **/